<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} ${hasRequiredError}`"
    :data-type="context.type"
    @click="handleOpenModal"
  >
    <div
      class="mc-input d-inline-flex"
      :class="{
        'input-md': size == 'md',
        'input-sm': size == 'sm',
        __disabled: disabled,
        __multiple: hasSelected,
      }"
    >
      <!-- This input field is only used to show placeholder using regular input style -->
      <!-- If no value is selected -->
      <input
        v-if="!hasSelected"
        :placeholder="attrs.placeholder || context.label"
        style="border: 0"
        readonly
      />
      <div v-else-if="multiple" class="d-flex gap-2 flex-wrap">
        <template v-for="(value, index) in localFullObject || context.model">
          <div
            v-if="index < 2"
            :key="index"
            v-b-tooltip.hover="value[displayedBy]?.length > 25 ? value[displayedBy] : null"
            class="__tag"
          >
            <span>{{
              value[displayedBy]?.length > 25
                ? value[displayedBy]?.slice(0, 22) + '...'
                : value[displayedBy]
            }}</span>
            <i class="icon-outline_close" @click.stop="handleRemoveTag(value)" />
          </div>
          <div v-else-if="index == 2" class="__count">
            <i class="icon-fill_plus" />
            <span>{{ context.model.length - 2 }}</span>
          </div>
        </template>
      </div>
      <div v-else-if="localFullObject?.[displayedBy]">
        {{ localFullObject[displayedBy] }}
      </div>
      <div v-else>
        {{ context.model }}
      </div>

      <i class="icon-fill_menu" />
    </div>

    <ModalValueHelp
      :context="context"
      :attrs="attrs"
      :multiple="multiple"
      :fullObject="localFullObject"
      @update:fullObject="onUpdate"
    >
      <template v-for="(val, key) in slotFields" #[val.name]="{ item }">
        <!-- eslint-disable-next-line vue/require-component-is -->
        <component :is="val.slotComponent" :key="key" :item="item" />
      </template>
    </ModalValueHelp>
  </div>
</template>

<script>
import ModalValueHelp from './components/ModalValueHelp'
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    ModalValueHelp,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },

    size: {
      type: String,
      default: 'md',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    displayedBy: {
      type: String,
    },

    fullObject: {},
  },
  emits: ['update:fullObject'],
  data() {
    return {
      localFullObject: {},
    }
  },
  computed: {
    // Shorthand for accessing context attributes
    attrs() {
      return this.context.attributes
    },

    slotFields() {
      return this.attrs?.tableFields ? this.attrs.tableFields.filter((v) => v.isSlot) : []
    },

    // add classes if it has validation error
    hasRequiredError() {
      if (this.context.visibleValidationErrors.includes('Wajib diisi'))
        return 'formulate-input-error__required'
      return ''
    },

    // if there is selected value(s)
    hasSelected() {
      if (this.multiple) return this.context.model.length !== 0
      return this.context.model !== ''
    },
  },
  watch: {
    fullObject: {
      handler(val) {
        this.localFullObject = this.multiple ? [...val] : { ...val }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    isEmpty,
    onUpdate($event) {
      this.localFullObject = this.multiple ? [...$event] : { ...$event }
      this.$emit('update:fullObject', $event)
    },
    handleOpenModal() {
      if (this.disabled) return
      this.$bvModal.show(`${this.attrs.name}-modal-value-help`)
    },
    handleRemoveTag(value) {
      if (!this.multiple || !Array.isArray(this.fullObject)) return

      const clickedTagIdx = this.context.model.findIndex((v) => v == value[this.attrs.trackBy])
      if (clickedTagIdx === -1) return

      const values = [...this.context.model]
      const localFullObject = Object.values(this.localFullObject)

      values.splice(clickedTagIdx, 1)
      localFullObject.splice(clickedTagIdx, 1)
      this.context.model = values

      this.localFullObject = localFullObject
      this.$emit('update:fullObject', localFullObject)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
